import styled from "styled-components";

export const Link = styled.div`
  display: flex;
  align-items: center;
  color: var(--main-color);
  font-weight: bold;
  cursor: pointer;
`;
